import { useLocation, useRouteLoaderData } from '@remix-run/react';

import type { loader as rootLoader } from '~/root';
import { defaultLocale, detectLocale } from '~/utils/language';

/**
 * Hook to get the current locale, respecting channel's default locale.
 * Use this instead of calling detectLocale directly in client components.
 */
export function useLocale(): string {
  const data = useRouteLoaderData<typeof rootLoader>('root');
  const { pathname } = useLocation();

  // If we have root loader data, use its locale directly (already computed with channel default)
  if (data?.locale) {
    return data.locale;
  }

  // Fallback: detect from pathname using channel's defaultLocale
  const channelDefaultLocale = data?.channelConfig?.defaultLocale ?? defaultLocale;
  return detectLocale(pathname, channelDefaultLocale);
}
